import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ConditionsGeneralesPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      <Navbar />

      <section className="pt-32 pb-16 bg-[#1a2e4a]">
        <div className="max-w-6xl mx-auto px-6">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white/40 mb-4">Mentions légales</p>
          <h1 className="text-4xl font-light text-white leading-tight tracking-tight">
            Conditions <span className="font-semibold">générales</span>
          </h1>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <div className="prose prose-sm max-w-none text-gray-600 leading-relaxed">

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">1. Présentation de l&apos;entreprise</h2>
              <p className="text-sm leading-relaxed mb-3">
                Le présent site internet est édité par :
              </p>
              <div className="bg-[#f5f4f2] rounded-lg p-5 text-sm">
                <p><strong>BONIEK</strong></p>
                <p>Dominika Julia Boniek</p>
                <p>Entrepreneur individuel</p>
                <p>SIRET : 102 005 980 00010</p>
                <p>Activité : 70.22Z – Conseil pour les affaires et autres conseils de gestion</p>
                <p className="mt-2">27 Rue Malbec, 33800 Bordeaux, France</p>
                <p>Email : dom1n1kaboniek@outlook.com</p>
                <p>Téléphone : +33 7 51 10 87 91</p>
              </div>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">2. Objet</h2>
              <p className="text-sm leading-relaxed">
                Les présentes conditions générales régissent l&apos;utilisation du site internet de BONIEK. En accédant à ce site, vous acceptez sans réserve les présentes conditions.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">3. Services présentés</h2>
              <p className="text-sm leading-relaxed">
                Le site présente les services de conseil en gestion et développement d&apos;entreprise proposés par BONIEK. Les informations publiées sont fournies à titre informatif et ne constituent pas un engagement contractuel.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">4. Propriété intellectuelle</h2>
              <p className="text-sm leading-relaxed">
                Tous les contenus présents sur ce site (textes, images, logos, structure) sont protégés par le droit de la propriété intellectuelle. Toute reproduction, même partielle, est interdite sans autorisation préalable écrite de BONIEK.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">5. Responsabilité</h2>
              <p className="text-sm leading-relaxed">
                BONIEK s&apos;efforce de maintenir les informations du site à jour et exactes. Toutefois, BONIEK ne saurait être tenu responsable des erreurs, omissions ou résultats obtenus par un mauvais usage des informations publiées.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">6. Droit applicable</h2>
              <p className="text-sm leading-relaxed">
                Les présentes conditions générales sont soumises au droit français. Tout litige relatif à leur interprétation ou exécution relève de la compétence des tribunaux français.
              </p>
            </div>

            <p className="text-xs text-gray-400 mt-12 pt-6 border-t border-gray-100">
              Dernière mise à jour : avril 2026
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
